import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=72e24f1e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e24f1e')) {
      api.createRecord('72e24f1e', component.options)
    } else {
      api.reload('72e24f1e', component.options)
    }
    module.hot.accept("./Sticker.vue?vue&type=template&id=72e24f1e&", function () {
      api.rerender('72e24f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/VueFormComponents/Sticker/Sticker.vue"
export default component.exports